import { render, staticRenderFns } from "./cheval-blanc.vue?vue&type=template&id=2ff1044b&scoped=true"
import script from "./cheval-blanc.vue?vue&type=script&lang=js"
export * from "./cheval-blanc.vue?vue&type=script&lang=js"
import style0 from "./cheval-blanc.vue?vue&type=style&index=0&id=2ff1044b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff1044b",
  null
  
)

export default component.exports